import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { Convention } from '../../../concepts/objects';
import { Point } from '../../../platform/geom/Point';
import { Physical } from '../../canvas/entities/Physical';
import { ConnectTarget } from './ConnectTarget';

export const Connectable = new Convention<Connectable>('Connectable');

export interface ConnectInfo {
    readonly target: ConnectTarget;
    readonly command: CommandDefinition<[]>;
}

export interface DisconnectInfo {
    readonly command: CommandDefinition<[]>;
}

export interface Connectable extends Physical {

    queryConnect(node: number, mpt: Point, target: ConnectTarget): ConnectInfo | null;

    queryDisconnect(node: number): DisconnectInfo;
}
